import { Quiz } from '@/models/Quiz';
import { QuizContent } from '@/models/QuizContent';
import { QuizData } from '@/models/QuizData';
import { AxiosError } from 'axios';

export enum QuizTypes {
    CLEAR_QUIZ = '@quiz/CLEAR_QUIZ',

    POST_QUIZ_REQUEST = '@quiz/POST_QUIZ_REQUEST',
    POST_QUIZ_SUCCESS = '@quiz/POST_QUIZ_SUCCESS',
    POST_QUIZ_FAILURE = '@quiz/POST_QUIZ_FAILURE',
    GET_AUTO_EXECUTABLE_QUIZ_REQUEST = '@quiz/GET_AUTO_EXECUTABLE_QUIZ_REQUEST',
    GET_AUTO_EXECUTABLE_QUIZ_SUCCESS = '@quiz/GET_AUTO_EXECUTABLE_QUIZ_SUCCESS',
    GET_AUTO_EXECUTABLE_QUIZ_FAILURE = '@quiz/GET_AUTO_EXECUTABLE_QUIZ_FAILURE',
    GET_QUIZ_RESULT_LIST_REQUEST = '@quiz/GET_QUIZ_RESULT_LIST_REQUEST',
    GET_QUIZ_RESULT_LIST_SUCCESS = '@quiz/GET_QUIZ_RESULT_LIST_SUCCESS',
    GET_QUIZ_RESULT_LIST_FAILURE = '@quiz/GET_QUIZ_RESULT_LIST_FAILURE',
    GET_QUIZ_RESULT_REQUEST = '@quiz/GET_QUIZ_RESULT_REQUEST',
    GET_QUIZ_RESULT_SUCCESS = '@quiz/GET_QUIZ_RESULT_SUCCESS',
    GET_QUIZ_RESULT_FAILURE = '@quiz/GET_QUIZ_RESULT_FAILURE',
    POST_QUIZ_RESULT_REQUEST = '@quiz/POST_QUIZ_RESULT_REQUEST',
    POST_QUIZ_RESULT_SUCCESS = '@quiz/POST_QUIZ_RESULT_SUCCESS',
    POST_QUIZ_RESULT_FAILURE = '@quiz/POST_QUIZ_RESULT_FAILURE',
    GET_QUIZ_QUESTION_LIST_REQUEST = '@quiz/GET_QUIZ_QUESTION_LIST_REQUEST',
    GET_QUIZ_QUESTION_LIST_SUCCESS = '@quiz/GET_QUIZ_QUESTION_LIST_SUCCESS',
    GET_QUIZ_QUESTION_LIST_FAILURE = '@quiz/GET_QUIZ_QUESTION_LIST_FAILURE',
    POST_QUIZ_QUESTION_REQUEST = '@quiz/POST_QUIZ_QUESTION_REQUEST',
    POST_QUIZ_QUESTION_SUCCESS = '@quiz/POST_QUIZ_QUESTION_SUCCESS',
    POST_QUIZ_QUESTION_FAILURE = '@quiz/POST_QUIZ_QUESTION_FAILURE',
    PUT_QUIZ_QUESTION_REORDER_REQUEST = '@quiz/PUT_QUIZ_QUESTION_REORDER_REQUEST',
    PUT_QUIZ_QUESTION_REORDER_SUCCESS = '@quiz/PUT_QUIZ_QUESTION_REORDER_SUCCESS',
    PUT_QUIZ_QUESTION_REORDER_FAILURE = '@quiz/PUT_QUIZ_QUESTION_REORDER_FAILURE',
}

export interface QuizState {
    data: {
        autoExecutable: Quiz;
        quizData: QuizData;
        quizzes: QuizContent[];
    };
    loading: boolean;
    success: boolean;
    hasError: boolean;
    error?: AxiosError;
}
